import { TranslationKeys } from '~frontend-common/i18n/english/pool-subquestion.i18n';

const keys: TranslationKeys = {
  poolSubquestion: {
    title: 'Quand la piscine a-t-elle été installée?',
    placeholder: "Année d'installation",
  },
};

export default keys;
